var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VImg',_vm._b({attrs:{"src":_vm.blobUrl},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope || {})]}}})],null,true)},'VImg',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }